import { JobQueuePage } from '@client/components/_business/jobs/JobQueuePage';
import type { JobData } from '@client/components/_business/jobs/JobTable';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/advanced/jobs/on-demand')({
    staticData: {
        breadcrumb: { title: 'On-demand jobs' },
        ui: {
            title: 'On-demand jobs',
            subtitle: 'User-triggered and system-initiated one-time background jobs',
            widthVariant: 'default',
            menuDescription: 'User-triggered jobs',
        },
    },
    component: OnDemandJobs,
});

function OnDemandJobs() {
    const navigate = useNavigate();

    const handleJobClick = (job: JobData) => {
        if (job?.id) {
            navigate({ to: '/admin-console/advanced/jobs/on-demand/$jobId', params: { jobId: job.id.toString() } });
        }
    };

    return (
        <JobQueuePage
            route={Route}
            jobType="on-demand"
            documentTitle="On-demand jobs"
            showProcessingInTitle
            processingStat="highlight"
            searchPlaceholder="Search by ID, name, status, or error..."
            onJobClick={handleJobClick}
        />
    );
}
